import React from 'react';
import { UiImage, UiBox, UiGrid, UiFlex } from '@open-stack/ui';
import styled from 'styled-components';
import { XLink } from '../../x/link/XLink';
import { XText } from '@orderx/lab/ui';

const Wrapper = styled(UiBox)`
    background-color: var(--x-color-surface);
    position: relative;
    overflow: hidden;
    box-shadow: var(--XCard-box-shadow);
    border-radius: var(--XCard-border-radius);
    //height: 150px;
    transform: translateZ(0);
    width: 100%;
    height: 96px;

    .image-container {
        height: 100%;
        position: relative;
        overflow: hidden;

        img {
            object-position: center;
        }
    }

    .button-container {
        background-image: linear-gradient(135deg, transparent 50%, var(--x-color-surface) 0);
        position: absolute;
        bottom: 0;
        right: 0;
        width: calc(1.75 * var(--ui-size-0));
        height: calc(1.75 * var(--ui-size-0));
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }

    .closed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .closed {
        background-color: var(--ui-color-overlay);
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: calc(4 * var(--ui-spacing));
        text-align: center;
    }
`;

interface Props {
    to?: any;
    name: string;
    description?: string;
    image?: string;
    isClosed?: boolean;

    onClick?(): void;
}

export function LocationCard({ to, name, description, image, isClosed, onClick }: Props) {
    const content = (
        <UiFlex direction="column" alignItems="flex-start" gap={1} paddingBottom={2}>
            <Wrapper
                onClick={() => {
                    if (!isClosed) {
                        onClick?.();
                    }
                }}>
                {isClosed && (
                    <div className="closed">
                        <XText>{name} is currently closed</XText>
                    </div>
                )}

                {image && (
                    <div className="image-container">
                        <UiImage src={image} type="cover" />
                    </div>
                )}
            </Wrapper>

            <UiGrid gap={0} paddingLeft={1}>
                <XText>{name}</XText>

                {description && (
                    <XText color={'text-secondary'} size={-1}>
                        {description}
                    </XText>
                )}
            </UiGrid>
        </UiFlex>
    );

    if (to) {
        return <XLink to={to}>{content}</XLink>;
    } else {
        return content;
    }
}
